export default __webpack_public_path__ + "static/media/RedEllipse.e23337ec.svg";